// src/pages/OAuthCallback.jsx
import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import api from "@/api/api";
import { setAccessToken, setRefreshToken } from "@/utils/tokenCookies";
import { message } from "antd";
const VITE_CALLBACK_LOGIN = import.meta.env.VITE_CALLBACK_LOGIN;


export default function OAuthCallback() {
  const [params] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const code = params.get("code");
    if (!code) {
      navigate("/", { replace: true });
      return;
    }

    (async () => {
      try {
        const { data } = await api.post(`/oauth/${VITE_CALLBACK_LOGIN}`, {
          code, 
          fcm_token: ""
        });

        const accessToken = data?.data?.access_token;
        const refreshToken = data?.data?.refresh_token;

        if (accessToken && refreshToken) {
          setAccessToken(accessToken);
          setRefreshToken(refreshToken);
          message.success(data?.message || "Muvaffaqiyatli kirdingiz!");
          navigate("/", { replace: true });
        } else {
          message.error("Kirishda xatolik yuz berdi, qayta urinib ko‘ring.");
          navigate("/login", { replace: true });
        }
      } catch (err) {
        message.error("Kirishda xatolik yuz berdi, qayta urinib ko‘ring.");
        navigate("/login", { replace: true });
      }
    })();
  }, [params, navigate]);

  return (
    <div
      className="d-flex flex-column justify-content-center align-items-center position-fixed top-0 start-0 w-100 h-100"
      style={{
        zIndex: 1050,
        background: `radial-gradient(1200px circle at 10% 10%, rgba(99,102,241,.25), transparent 40%), 
                 radial-gradient(1200px circle at 90% 90%, rgba(236,72,153,.22), transparent 40%), 
                 linear-gradient(180deg, rgba(15,23,42,.85), rgba(15,23,42,.85))`,
        color: "#fff",
      }}
    >
      <div
        className="spinner-border text-light mb-3"
        style={{ width: "2.5rem", height: "2.5rem" }}
        role="status"
      >
        <span className="visually-hidden">Loading...</span>
      </div>


      <p className="opacity-75 mb-0">
        OAuth jarayoni yakunlanmoqda, iltimos kuting...

      </p>
    </div>

  );
}
